import React, { useState } from 'react';
import { Post } from '../types';
import MasonryCard from './MasonryCard';
import PostDetailModal from './PostDetailModal';

interface MasonryGridProps {
  posts: Post[];
  onLike: (postId: string) => void;
  onSave: (postId: string) => void;
}

const MasonryGrid: React.FC<MasonryGridProps> = ({ posts, onLike, onSave }) => {
  const [selectedPost, setSelectedPost] = useState<Post | null>(null);
  const [showDetailModal, setShowDetailModal] = useState(false);

  const handleOpenDetail = (post: Post) => {
    console.log('Opening detail for post:', post);
    setSelectedPost(post);
    setShowDetailModal(true);
  };

  const handleCloseDetail = () => {
    setShowDetailModal(false);
    setSelectedPost(null);
  };

  const handleDeletePost = (postId: string) => {
    // Remove from local state immediately
    // In a real app, you might want to refresh the parent component
    console.log('Post deleted:', postId);
    setShowDetailModal(false);
    setSelectedPost(null);
    // Emit event to refresh posts
    window.dispatchEvent(new CustomEvent('postDeleted', { detail: { postId } }));
  };

  return (
    <>
      {/* Masonry Grid */}
      <div 
        className="masonry-grid"
        style={{
          columnCount: 'auto',
          columnWidth: '300px',
          columnGap: '1rem',
          columnFill: 'balance',
        }}
      >
        {posts.map((post) => (
          <MasonryCard
            key={post.id}
            post={post}
            onLike={onLike}
            onSave={onSave}
            onOpenDetail={handleOpenDetail}
          />
        ))}
      </div>

      {/* CSS for better masonry support */}
      <style jsx>{`
        .masonry-grid {
          column-count: auto;
          column-width: 300px;
          column-gap: 1rem;
          column-fill: balance;
        }
        
        @media (max-width: 640px) {
          .masonry-grid {
            column-width: 280px;
            column-gap: 0.75rem;
          }
        }
        
        @media (min-width: 1024px) {
          .masonry-grid {
            column-width: 320px;
            column-gap: 1.5rem;
          }
        }
        
        @media (min-width: 1280px) {
          .masonry-grid {
            column-width: 350px;
            column-gap: 2rem;
          }
        }
      `}</style>

      {/* Detail Modal */}
      {showDetailModal && selectedPost && (
        <PostDetailModal
          post={selectedPost}
          onClose={handleCloseDetail}
          onDelete={handleDeletePost}
          onLike={onLike}
          onSave={onSave}
        />
      )}
    </>
  );
};

export default MasonryGrid;